import React from 'react'
import { CircularProgress, Grid } from '@mui/material'

import {OfficesAutocomplete, NoDataFound, AppOfficesAutocomplete} from '@components'
import ReportListHistoricalModalContentTable from './Table'
import LoadingText from 'Pages/ReportsAlerts/Reports/@components/CrudTable/LoadingText'
import { useInfoModalHistorical } from 'Pages/ReportsAlerts/Reports/@hooks'
import {BACKEND_APIS} from "../../../../../../../@constants";


export default function ReportInfoModalHistoricalContent({ id_report, rowData }) {
	const {
		offices, officeSelected, setOfficeSelected, numOffices, isLoadingHistoricalData, reportName, historicalOfficeData, officeOptions, idLastExecution
	} = useInfoModalHistorical(id_report, rowData)

	return <Grid container spacing={2}>
		<Grid item xs={6}>
			<AppOfficesAutocomplete
				onFinishAjax={opts => officeOptions.value = opts}
				options={officeOptions.value}
				value={officeSelected}
				onChange={e => setOfficeSelected(e.target.value)}
				disabled={numOffices === 1}
				urlAjax={`${BACKEND_APIS.EXECUTION_INFO}/offices`}
				filters={{
					idReportExecution: idLastExecution,
					noFilterStatus: true
				}}
			/>
		</Grid>

		<Grid item xs={6}/>

		{!!isLoadingHistoricalData && <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}>
			<LoadingText label="Loading historical" variant="subtitle1" sx={{ my: 2 }}/>
			<CircularProgress size={120}/>
		</Grid>}

		{!isLoadingHistoricalData && !officeSelected && !historicalOfficeData.length && <Grid item xs={12}>
			<NoDataFound />
		</Grid>
		}

		{!isLoadingHistoricalData && !!historicalOfficeData.length && <Grid item xs={12}>
			<ReportListHistoricalModalContentTable
				reportName={reportName}
				pickUp={offices}
				data={historicalOfficeData}
				hasCompetitionSites={rowData.hasCompetitionSites}
				hasDirectSites={rowData.hasDirectSites}
				hasGenerate={rowData.generate}
				hasExport={rowData.export}
				isRunning={rowData.statusLastExecution === "running"}
				officeSelected={officeSelected}
			/>
		</Grid>}
	</Grid>
}